const EVENT_OFFER_RESPONSE = 'event-offer-response';
const offerResponseEventTrigger = () => {
  const event = new CustomEvent(EVENT_OFFER_RESPONSE);
  document.dispatchEvent(event);
};

export {EVENT_OFFER_RESPONSE, offerResponseEventTrigger};